<template>
  <section class="checkout">
    <div class="checkout__infosUser">
      <form
        class="checkout__informacoesIniciais"
        v-if="vendedorResponsavel != null || parceiros.length > 0"
      >
        <h1>INFORMAÇÕES INICIAIS</h1>
        <div class="rows">
          <div class="form-groups" v-if="parceiros.length > 0">
            <label class="label">Vendedor Responsável</label>
            <input
              type="text"
              class="input large"
              disabled
              :value="usuarioLogado"
            />
          </div>
          <div class="form-groups" v-if="parceiros.length <= 0">
            <label class="label">Vendedor Responsável</label>
            <input
              type="text"
              class="input large"
              disabled
              :value="vendedorResponsavel"
            />
          </div>
          <div class="form-groups" v-if="parceiros.length > 0">
            <label class="label">Parceiro</label>
            <select
              class="input medium"
              id="parceiro"
							@change="validaProfitz"
              v-model="parceiroSelecionado"
            >
              <option
                v-for="(parc, index) in parceiros"
                :key="index"
                :value="parc"
              >
                {{ parc.nomeParceiro }}
              </option>
            </select>
          </div>
        </div>
      </form>

      <form class="checkout__dadosPessoais">
        <h1>DADOS PESSOAIS</h1>
        <div class="rows">
          <div class="form-groups">
            <label class="label">CPF ou CNPJ</label>
            <the-mask
              v-model="cpfcnpj"
              type="text"
              class="input medium"
              @keypress.enter="getClient()"
              @change.native="getClient()"
              required
              :mask="['###.###.###-##', '##.###.###/####-##']"
            />
          </div>
          <div class="form-groups">
            <label class="label">Nome Completo</label>
            <input
              disabled
              type="text"
              class="input large"
              v-model="client.name"
              required
            />
          </div>
        </div>
        <div class="rows">
          <div class="form-groups">
            <label class="label">E-mail</label>
            <input
              disabled
              type="email"
              class="input
              large"
              v-model="client.email"
              required
            />
          </div>
          <div class="form-groups">
            <label class="label">Telefone ou Celular</label>
            <input
              disabled
              type="text"
              class="input medium"
              v-model="client.phone"
              required
            />
          </div>
        </div>
      </form>

      <div class="checkout__pessoaJuridica">
        <form class="checkout__pessoaJuridica--form">
          <div class="rows">
            <div class="form-groups">
              <label class="label">Razão Social</label>
              <input
                v-model="client.corporateName"
                type="text"
                class="input large"
                disabled
              />
            </div>
            <div class="form-groups">
              <label class="label">Nome Fantasia</label>
              <input
                v-model="client.fantasyName"
                disabled
                type="text"
                class="input medium"
              />
            </div>
          </div>
          <div class="rows">
            <div class="form-groups">
              <label class="label">Inscrição Estadual</label>
              <input
                v-model="client.stateRegistration"
                disabled
                type="text"
                class="input medium"
              />
            </div>
          </div>
        </form>
      </div>

      <!-- Listagem de endereços -->
      <div class="checkout__enderecoEntrega">
        <h1>ENDEREÇO DE ENTREGA</h1>
        <v-radio-group
          v-model="selectedAddress"
        >
          <div
            class="checkout__enderecoEntrega--opcoes"
          >
            <v-radio
              color="#005a64"
              class="checkout__enderecoEntrega--opcoes--item"
              v-for="(dados, index) in infos.endereco"
              :key="index"
              :value="dados"
            >
              <template v-slot:label>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    margin-left: 10px;
                    word-break: break-all;
                    font-size: 0.875rem;
                  "
                >
                  <p>
                    {{ dados.logradouro }},{{ dados.nrresidencia }}
                  </p>
                  <p>{{ dados.bairro }}</p>
                  <p>{{ dados.complemento }}</p>
                  <p>{{ dados.cep }}</p>
                  <p>{{ dados.cidade }}, {{ dados.uf }}</p>
                </div>
              </template>
            </v-radio>

            <!-- Item de Adicionar novo endereço -->
            <div
              v-if="infos.endereco"
              class="checkout__enderecoEntrega--opcoes--item"
              style="
                cursor: pointer;
                margin-bottom: 8px;
                color: rgba(0, 0, 0, 0.6);
                text-align: center;
              "
              @click="novoEndereco.active = !novoEndereco.active"
            >
              <p>Adicionar endereço</p>
              <div
                class="checkout__enderecoEntrega--novoEndereco"
                style="text-align: center; font-size: xx-large; color: #002d32; padding: 25px">
                <i class="fa fa-plus-circle"></i>
              </div>
            </div>
          </div>
        </v-radio-group>

        <!-- Novo endereço -->
        <div
          class="checkout__enderecoEntrega--novoEndereco--form"
          v-if="novoEndereco.active"
        >
          <h1>NOVO ENDEREÇO</h1>
          <div class="rows">
            <div class="form-groups">
              <label class="label">CEP</label>
              <the-mask class="input medium" :mask="['#####-###']" type="text" @change.native="buscaCEP()" v-model="novoEndereco.cep"/>
            </div>
            <div class="form-groups">
              <label class="label">Rua / Avenida</label>
              <input type="text" class="input medium" required v-model="novoEndereco.logradouro"/>
            </div>

            <div class="form-groups">
              <label class="label">Número</label>
              <input type="number" class="input medium" required v-model="novoEndereco.nrresidencia"/>
            </div>
          </div>
          <div class="rows">
            <div class="form-groups">
              <label class="label">Bairro</label>
              <input type="text" class="input medium" required v-model="novoEndereco.bairro"/>
            </div>
            <div class="form-groups">
              <label class="label">Complemento <span>(opcional)</span></label>
              <input type="text" class="input medium" v-model="novoEndereco.complemento"/>
            </div>
            <div class="form-groups">
              <label class="label">Cidade</label>
              <input type="text" class="input medium" required v-model="novoEndereco.cidade"/>
            </div>
          </div>
          <div class="rows">
            <div class="form-groups">
              <label class="label">Estado</label>
              <input type="text" class="input medium" required v-model="novoEndereco.uf"/>
            </div>
            <button
              style="
                font-size: 0.938rem;
                color: #fff;
                background: #002d32;
                font-weight: bold;
                padding: 5px;
                text-align: center;
                border-radius: 7px;
                outline: none;
                margin-top: 35px;
                box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 10%),
                  0px 2px 2px 0px rgb(0 0 0 / 14%),
                  0px 1px 5px 0px rgb(0 0 0 / 12%);"
              @click="salvaNovoEndereco()">
              Salvar
            </button>
          </div>
        </div>
        <div
          class="checkout__enderecoEntrega--novoEndereco--form"
        >
          <h1>RESPONSÁVEL PELO RECEBIMENTO</h1>
          <div class="rows">
            <div class="form-groups">
              <label class="label">Nome</label>
              <input maxlength="20" class="input medium" type="text" v-model="responsavel.nome"/>
            </div>
          </div>
          <div class="rows">
            <div class="form-groups">
              <label class="label">Telefone ou celular</label>
              <the-mask type="text" :mask="['(##) #####-####', '(##) ####-####']" class="input medium" id="rua" v-model="responsavel.telefone"/>
            </div>
          </div>
        </div>
      </div>

      <form class="checkout__opcoesEnvio">
        <h1>OPÇÕES DE ENVIO</h1>
        <div class="rows">
          <div class="checkout__opcoesEnvio--loader" v-if="loader">
            <span><i class="fas fa-stroopwafel fa-spin fa-3x"></i></span>
            <span>Calculando frete...</span>
          </div>
          <v-radio-group v-if="!loader">
            <v-radio
              color="#005a64"
              v-for="s in sla"
              :key="s.tipo"
              :label="s.textoFrete"
              @change="selecionaSLA(s)"
              :value="s.sla"
            ></v-radio>
          </v-radio-group>
        </div>

        <div v-if="slaSelecionado && slaSelecionado.tipo === 'Agendada'">
          <div class="rows">
            <p>Selecione uma data agendada:</p>
          </div>
          <div class="rows">
            <select class="input large" v-model="dataEscolhida">
              <option v-for="(d, i) in dataSelecionada" :key="i" :value="d">
                {{
                  `Entre ${moment(d.startDateUtc).format(
                    "DD/MM/YYYY HH:mm"
                  )} à ${moment(d.endDateUtc).format("DD/MM/YYYY HH:mm")}`
                }}
              </option>
            </select>
          </div>
        </div>
      </form>


      <div class="checkout__pagamentoSolar" v-if="!isPartner">
        <h1>VALOR NEGOCIADO</h1>
        <div class="rows">
          <div class="form-groups">
            <money
              class="input medium"
              v-model.lazy="valorNegociado"
              v-bind="money"
              @blur.native="valorNegociado < 0 ? valorNegociado = 0 : true"
            ></money>
          </div>
        </div>
      </div>

      <form class="checkout__opcoesEnvio">
        <v-checkbox
          color="#005a64"
          v-model="moreThanOnePayment"
          label="Selecionar mais de uma forma de pagamento"
          :value="true"
          @click="
            indexPrimeiroPagamento = null;
            valorPagamento = 0;
          "
        ></v-checkbox>
      </form>

      <div v-if="moreThanOnePayment" class="checkout__pagamentoSolar">
        <h1><span>1º </span>FORMA DE PAGAMENTO</h1>
        <v-btn-toggle
          v-model="indexPrimeiroPagamento"
          color="#005a64"
          dense

          style="
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: center;
            gap: 10px;
          "
        >
          <v-btn
            v-for="(formas, i) in formaPagamentoSolar"
            :key="i"
            style="
              width: 100%;
              max-width: 248px;
              color: #005a64;
            "
            text
          >
            <div>
              <v-icon v-if="formas.descricao.toLowerCase().includes('cartão de crédito')">mdi-credit-card</v-icon>
              <v-icon v-else-if="formas.descricao.toLowerCase().includes('financiamento')">mdi-bank</v-icon>
              <v-icon v-else-if="formas.descricao.toLowerCase().includes('boleto')">mdi-barcode</v-icon>
              <v-icon v-else-if="formas.descricao.toLowerCase().includes('deposito')">mdi-cash</v-icon>
              <v-icon v-else-if="formas.descricao.toLowerCase().includes('vale')">mdi-ticket</v-icon>
              <v-icon v-else-if="formas.descricao.toLowerCase().includes('pix')">mdi-currency-usd</v-icon>
              <v-icon v-else-if="formas.descricao.toLowerCase().includes('gift card')">mdi-gift</v-icon>
            </div>
            <div style="margin-left: 15px;">{{ formas.descricao }}</div>
          </v-btn>
        </v-btn-toggle>

        <div v-if="indexPrimeiroPagamento !== null && indexPrimeiroPagamento !== undefined">
          <v-divider style="margin: 10px 0 10px;"></v-divider>
          <h1><span>1º </span>Forma de pagamento selecionada:</h1>

          <div>
            {{ formaPagamentoSolar[indexPrimeiroPagamento].descricao }}
						<span v-if="formaPagamentoSolar[indexPrimeiroPagamento].descricao.toLowerCase() =='profitz'">Saldo: {{valorProfitz}}</span>
          </div>

          <!-- Valor de pagamento -->
          <div>
            <label class="label">Valor de pagamento:</label>
            <div class="rows">
              <div class="form-groups">
                <money
                  class="input medium"
                  v-model.lazy="valorPagamento"
                  v-bind="money"
                  @blur.native="
                    valorPagamento < 0 ? valorPagamento = 0 :
                    valorPagamento > valorTotalNF ? valorPagamento = valorTotalNF : true
                  "
                ></money>
              </div>
            </div>
          </div>

          <div v-if="formaPagamentoSolar[indexPrimeiroPagamento].condicoesDePagamento.length > 1">
            <label class="label">Condição de pagamento:</label>
            <div>
              <select
                class="input medium"
                v-model="condicaoPrimeiroPagamento"
              >
                <option
                  v-for="(parc, i) in formaPagamentoSolar[indexPrimeiroPagamento].condicoesDePagamento"
                  :value="parc"
                  :key="i"
                >
                  {{ parc.descricao }}
                </option>
              </select>
            </div>
          </div>

          <!-- Input do vale -->
          <div v-if="formaPagamentoSolar[indexPrimeiroPagamento].descricao.toLowerCase().includes('vale')">
            <div class="rows">
              <div class="form-groups">
                <label class="label" for="">Inserir Vale</label>
                <input type="text" class="input medium" id="valeCredito" />
              </div>
            </div>
          </div>

          <!-- Input do Gift card -->
          <div v-if="formaPagamentoSolar[indexPrimeiroPagamento].descricao.toLowerCase().includes('gift card')">
            <div class="rows">
              <div class="form-groups">
                <label class="label" for="">Inserir Gift Card</label>
                <input type="text" class="input medium" id="cardGift" />
              </div>
            </div>
          </div>

          <v-divider style="margin: 20px 0 10px;"></v-divider>
        </div>
      </div>

      <div class="checkout__pagamentoSolar">
        <h1><span v-if="moreThanOnePayment">2º </span>FORMA DE PAGAMENTO</h1>
        <v-btn-toggle
          v-model="indexPagamento"
          color="#005a64"
          dense
          style="
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: center;
            gap: 10px;
          "
        >
          <v-btn
            :disabled="formas.disabled"
            v-for="(formas, i) in formaPagamentoSolar"
            :key="i"
            style="
              width: 100%;
              max-width: 248px;
              color: #005a64;
            "
            text
          >
            <div>
              <v-icon v-if="formas.descricao.toLowerCase().includes('cartão de crédito')">mdi-credit-card</v-icon>
              <v-icon v-else-if="formas.descricao.toLowerCase().includes('financiamento')">mdi-bank</v-icon>
              <v-icon v-else-if="formas.descricao.toLowerCase().includes('boleto')">mdi-barcode</v-icon>
              <v-icon v-else-if="formas.descricao.toLowerCase().includes('deposito')">mdi-cash</v-icon>
              <v-icon v-else-if="formas.descricao.toLowerCase().includes('vale')">mdi-ticket</v-icon>
              <v-icon v-else-if="formas.descricao.toLowerCase().includes('pix')">mdi-currency-usd</v-icon>
              <v-icon v-else-if="formas.descricao.toLowerCase().includes('gift card')">mdi-gift</v-icon>
            </div>
            <div style="margin-left: 15px;">{{ formas.descricao }}</div>
          </v-btn>
        </v-btn-toggle>

        <div v-if="indexPagamento !== null && indexPagamento !== undefined">
          <v-divider style="margin: 10px 0 10px;"></v-divider>
          <h1><span v-if="moreThanOnePayment">2º </span>Forma de pagamento selecionada:</h1>

          <div>
            {{ formaPagamentoSolar[indexPagamento].descricao }}
						<span v-if="formaPagamentoSolar[indexPagamento].descricao.toLowerCase() =='profitz'">Saldo: {{valorProfitz}}</span>
          </div>

          <!-- Valor de pagamento -->
          <div v-if="moreThanOnePayment">
            <label class="label">Valor de pagamento:</label>
            <div class="rows">
              <div class="form-groups">
                <money
                  disabled
                  class="input medium"
                  :value="valorSegundaFormaPagamento"
                  v-bind="money"
                ></money>
              </div>
            </div>
          </div>

          <div v-if="formaPagamentoSolar[indexPagamento].condicoesDePagamento.length > 1">
            <label class="label">Condição de pagamento:</label>
            <div>
              <select
                class="input medium"
                v-model="condicaoSelecionada"
              >
                <option
                  v-for="(parc, i) in formaPagamentoSolar[indexPagamento].condicoesDePagamento"
                  :value="parc"
                  :key="i"
                >
                  {{ parc.descricao }}
                </option>
              </select>
            </div>
          </div>

          <!-- Input do vale -->
          <div v-if="formaPagamentoSolar[indexPagamento].descricao.toLowerCase().includes('vale')">
            <div class="rows">
              <div class="form-groups">
                <label class="label" for="">Inserir Vale</label>
                <input type="text" class="input medium" id="valeCredito" />
              </div>
            </div>
          </div>

          <!-- Input do Gift card -->
          <div v-if="formaPagamentoSolar[indexPagamento].descricao.toLowerCase().includes('gift card')">
            <div class="rows">
              <div class="form-groups">
                <label class="label" for="">Inserir Gift Card</label>
                <input type="text" class="input medium" id="cardGift" />
              </div>
            </div>
          </div>

          <v-divider style="margin: 20px 0 10px;"></v-divider>
        </div>
      </div>

      <div class="checkout__observacoes" v-if="isCustomized">
        <h3>Inserir RT no valor</h3>
        <div style="width: auto">
          <v-radio-group row v-model="incluirRT">
            <v-radio
              color="#005a64"
              label="Sim"
              :value="true"
            ></v-radio>
            <v-radio
              color="#005a64"
              label="Não"
              :value="false"
            ></v-radio>
          </v-radio-group>
        </div>

        <div v-if="incluirRT" style="width: 50%">
          <div>
            <h3>RT:</h3>
            <money
              class="input medium"
              v-model.lazy="rtFlutuante"
              v-bind="money"
              @blur.native="rtFlutuanteBlur()"
            ></money>
            <b-form-input
              id="range-1"
              v-model="rtFlutuante"
              style="margin-top: 20px"
              class="custom-slider"
              type="range"
              step="0.01"
              :min="0"
              :max="valorSemRT * 0.8"
            ></b-form-input>
            <div>
              <span class="nao-selecionar">{{ 0 | toCurrency }}</span>
              <span class="nao-selecionar" style="float: right">{{
                (valorSemRT * 0.8) | toCurrency
              }}</span>
            </div>
          </div>
          <div style="margin-top: 10px">
            <h3>Valor Nota Fiscal Final:</h3>
            <money
              class="input medium"
              v-model.lazy="vlNotaFlutuante"
              v-bind="money"
              @blur.native="vlNotaFlutuanteBlur()"
            ></money>
            <b-form-input
              id="range-1"
              v-model="vlNotaFlutuante"
              style="margin-top: 20px"
              class="custom-slider"
              type="range"
              step="0.01"
              :min="valorSemRT"
              :max="valorSemRT + valorSemRT * 0.8"
            ></b-form-input>
            <div>
              <span class="nao-selecionar">{{ valorSemRT | toCurrency }}</span>
              <span class="nao-selecionar" style="float: right">{{
                (valorSemRT + valorSemRT * 0.8) | toCurrency
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="checkout__observacoes">
        <h3>OBSERVAÇÕES NOTA FISCAL</h3>
        <textarea
          name="observacoes"
          id="observacoes"
          v-model="observacoesPedido"
          maxlength="163"
        ></textarea>
      </div>
    </div>

    <div class="checkout__resumeOrder">
      <h1>RESUMO DO PEDIDO</h1>
      <div class="checkout__resume">
        <div
          class="checkout__resume--items"
          v-for="(item, index) in carrinho"
          :key="index"
        >
          <div class="checkout__resume--items--name">
            <a @click="productDetails(item.sku, item.valor)"
              ><img :src="item.imagem" width="80px" :alt="item.nomeItem"
            /></a>
            <p>
              <a @click="productDetails(item.sku, item.valor)">{{
                item.nomeItem
              }}</a>
            </p>
          </div>
          <div class="checkout__resume--items--valor">
            <p>{{ item.quantidade }} un</p>
            <p>
              {{ parseFloat(item.valor) | toCurrency }}
            </p>
          </div>
        </div>
        <div class="checkout__resume--totais">
          <div class="checkout__resume--totais--subtotal">
            <p><strong>SUBTOTAL</strong></p>
            <p>
              {{ totalCarrinho | toCurrency }}
            </p>
          </div>
          <div
            class="checkout__resume--totais--shipping"
            v-if="parseFloat(descontoFormaPagamento) > 0"
          >
            <p><strong>DESCONTO À VISTA</strong></p>
            <p>
              {{ parseFloat(descontoFormaPagamento) | toCurrency }} ({{
                (
                  100 -
                  ((totalCarrinho - descontoFormaPagamento) / totalCarrinho) * 100
                ).toFixed(2)
              }}%)
            </p>
          </div>
          <div
            class="checkout__resume--totais--shipping"
            v-if="parseFloat(descontoValorNegociado) > 0"
          >
            <p><strong>DESCONTO NEGOCIADO</strong></p>
            <p>
              {{ parseFloat(descontoValorNegociado) | toCurrency }} ({{
                (
                  100 -
                  ((totalCarrinho - descontoValorNegociado) / totalCarrinho) * 100
                ).toFixed(2)
              }}%)
            </p>
          </div>
          <div
            class="checkout__resume--totais--shipping"
            v-if="parseFloat(rtFlutuante) > 0"
          >
            <p><strong>RT A RECEBER</strong></p>
            <p>
              {{ parseFloat(rtFlutuante) | toCurrency }} ({{
                (
                  (
                    parseFloat(
                      parseFloat(rtFlutuante) /
                      ((parseFloat(valorSemRT)
                      )
                    ) * 100
                  ).toFixed(2))
                )
              }}%)
            </p>
          </div>
          <div class="checkout__resume--totais--shipping">
            <p><strong>ENTREGA</strong></p>
            <p v-if="slaSelecionado == null">A calcular</p>
            <p v-if="slaSelecionado != null">
              {{ slaSelecionado.preco | toCurrency }}
            </p>
          </div>
          <div
            class="checkout__resume--totais--shipping"
            v-if="jurosCondicao > 0"
          >
            <p><strong>JUROS CONDIÇÃO DE PAGAMENTO</strong></p>
            <p>
              <span> {{ parseFloat(valorTotalComJuros) | toCurrency }}</span>
            </p>
          </div>
          <div
            class="checkout__resume--totais--shipping"
            v-if="(jurosSobreNF - jurosCondicao) > 0"
          >
            <p><strong>JUROS SOBRE RT</strong></p>
            <p>
              <span> {{ (jurosSobreNF - jurosCondicao) | toCurrency }}</span>
            </p>
          </div>
          <div class="checkout__resume--totais--totais">
            <p><strong>TOTAL NOTA FISCAL</strong></p>
            <p>
              <!-- O total é o valor + os juros calculados -->
              {{ valorTotalNF | toCurrency }}
            </p>
          </div>

          <v-divider style="margin: 20px 0 10px;"></v-divider>

          <!-- Primeira forma de pagamento (Quando selecionada) -->
          <div v-if="indexPrimeiroPagamento !== null && indexPrimeiroPagamento !== undefined && formaPagamentoSolar[indexPrimeiroPagamento]">
            <div class="checkout__resume--totais--shipping">
              <p><strong>1º FORMA DE PAGAMENTO</strong></p>
              <p>
                {{ formaPagamentoSolar[indexPrimeiroPagamento].descricao }}
              </p>
            </div>
            <div class="checkout__resume--totais--shipping">
              <p><strong>VALOR</strong></p>
              <p>
                {{ parseFloat(valorPagamento) | toCurrency }}
              </p>
            </div>
            <div
              class="checkout__resume--totais--shipping"
              v-if="condicaoPrimeiroPagamento"
            >
              <p><strong>CONDIÇÃO DE PAGAMENTO</strong></p>
              <p>
                <span>{{ condicaoPrimeiroPagamento.descricao.toUpperCase() }}</span>
                <span
                  v-if="formaPagamentoSolar[indexPrimeiroPagamento].descricao.toLowerCase().includes('cartão de crédito')"
                >
                  {{ (parseFloat(valorPagamento) / condicaoPrimeiroPagamento.id) | toCurrency }}
                </span>
              </p>
            </div>
          </div>

          <v-divider
            style="margin: 20px 0 10px;"
            v-if="indexPrimeiroPagamento !== null && indexPrimeiroPagamento !== undefined && formaPagamentoSolar[indexPrimeiroPagamento]"
          />

          <!-- Forma de pagamento principal -->
          <div v-if="indexPagamento !== null && indexPagamento !== undefined && formaPagamentoSolar[indexPagamento]">
            <div class="checkout__resume--totais--shipping">
              <p><strong><span v-if="moreThanOnePayment">2º </span>FORMA DE PAGAMENTO</strong></p>
              <p>
                {{ formaPagamentoSolar[indexPagamento].descricao }}
              </p>
            </div>
            <div class="checkout__resume--totais--shipping" v-if="moreThanOnePayment">
              <p><strong>VALOR </strong></p>
              <p>
                {{ parseFloat(valorSegundaFormaPagamento) | toCurrency }}
              </p>
            </div>
            <div class="checkout__resume--totais--shipping" v-if="moreThanOnePayment">
              <p><strong>JUROS </strong></p>
              <p>
                {{ parseFloat(valorTotalComJuros) | toCurrency }}
              </p>
            </div>
            <div
              class="checkout__resume--totais--shipping"
              v-if="condicaoSelecionada"
            >
              <p><strong>CONDIÇÃO DE PAGAMENTO</strong></p>
              <p v-if="indexPrimeiroPagamento === null">
                <span>{{ condicaoSelecionada.descricao.toUpperCase() }}</span>
                <span
                  v-if="formaPagamentoSolar[indexPagamento].descricao.toLowerCase().includes('cartão de crédito')"
                >
                {{ valorParcelaCartao | toCurrency }}
                  <!-- {{ valorParcelaCalculada | toCurrency }} -->
                  {{
                    condicaoSelecionada.descontoMaximo
                      ? "COM JUROS DE " +
                        (-condicaoSelecionada.descontoMaximo) +
                        "% A.M."
                      : "SEM JUROS"
                  }}bbb
                </span>
              </p>
              <p v-else>
                <span>{{ condicaoSelecionada.descricao.toUpperCase() }}</span>
                <span
                  v-if="formaPagamentoSolar[indexPagamento].descricao.toLowerCase().includes('cartão de crédito')"
                > 
                  {{ 
                    (parseFloat(valorParcelaCartao)) | toCurrency 
                  }}
                  {{
                    condicaoSelecionada.descontoMaximo
                      ? "COM JUROS DE " +
                        (-condicaoSelecionada.descontoMaximo) +
                        "% A.M."
                      : "SEM JUROS"
                  }} 
                </span>
              </p>
            </div>
          </div>
        </div>

        <div @click="finalizaCompra" class="checkout__resume--finalizarCompra">
          <button>FINALIZAR COMPRA</button>
        </div>
        <div
          class="checkout__resume--finalizarOrcamento"
          v-if="vendedorResponsavel != null"
        >
          <button>FINALIZAR ORÇAMENTO</button>
        </div>
        <br />
        <v-app>
          <div v-if="bloqueios.length > 0">
            <h1>BLOQUEIOS</h1>
            <br />
            <v-alert
              v-for="bloqueio in bloqueios"
              :key="bloqueio.description"
              dense
              border="right"
              colored-border
              elevation="2"
              type="error"
            >
              {{ bloqueio.description }}
            </v-alert>
          </div>
        </v-app>
      </div>
    </div>
    <!-- Dialogo -->
    <v-dialog v-model="dialog.active" width="500">
      <v-card>
        <v-card-title
          class="headline"
          style="
            background: rgb(255, 206, 0);
            color: rgb(0, 90, 100);
            font-weight: bold;
          "
        >
          {{ dialog.title }}
        </v-card-title>
        <v-card-text
          class="mt-6"
          v-html="dialog.message"
          style="font-size: initial !important"
        >
          {{ dialog.message }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            v-if="dialog.denyAction"
            color="primary"
            text
            style="background-color: rgb(0, 90, 100)"
          >
            <span style="color: white">Cancelar</span>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog.actionFunction ? dialog.actionFunction() : dialog.active = false"
            style="background-color: rgb(0, 90, 100)"
          >
            <span style="color: white">OK</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>


<script>
import axios from "axios";
import { Money } from "v-money";

// Inicializa o cliente (Utilizado para resetar o mesmo)
function cleanClient() {
  return {
    name: null,
    email: null,
    phone: null,
    fantasyName: null,
    stateRegistration: null,
    corporateName: null,
  }
}

function cleanNewAddress() {
  return {
    active: false,
    cep: null,
    logradouro: null,
    cidade: null,
    uf: null,
    bairro: null,
    complemento: null,
    nrresidencia: null,
    Pais: null
  }
}

export default {
  data() {
    return {
      client: cleanClient(),
      novoEndereco: cleanNewAddress(),
      dialog: {
        active: false,
        title: null,
        message: null,
        actionFunction: null,
        denyAction: false
      },
      valorPagamento: 0,
      incluirRT: false,
      selectedAddress: null,
      moreThanOnePayment: false,
      indexPagamento: null,
      indexPrimeiroPagamento: null,
      condicaoPrimeiroPagamento: null,
      cpfcnpj: null,
      profitz: 0,
      usuarioLogado: null,
      valorProfitz: null,
			cnpjProfitz: null,
      parceiros: [],
      parceiro: false,
      vendedorResponsavel: null,
      token: JSON.parse(localStorage.getItem('login')).token,
      prazoMax: null,
      isPartner: false,
      carrinho: [],
      infos: [],
      cep: null,
      sla: null,
      slaSelecionado: null,
      totalCarrinho: 0,
      loader: false,
      enderecoEntrega: null,
      formaPagamentoSolar: [],
      valorNegociado: 0,
      descontoFPagamento: 0,
      descontoVNegociado: 0,
      condicaoSelecionada: null,
      dataSelecionada: [],
      dataEscolhida: null,
      parceiroSelecionado: null,
      valorParcelaCartao: 0,
      jurosParcelaCartao : 0,
      valorTotalComJuros: 0,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false,
      },
      observacoesPedido: null,
      isCustomized: false,
      rtFlutuante: 0,
      rtFlutuante2: 0,
      vlNotaFlutuante: 0,
      valorParcelaCalculada: 0,
      valorJurosCartao: 0,
      valorSemRT: 0,
      responsavel: {
        nome: null,
        telefone: null
      }
    };
  },
  components: { Money },
  watch: {
    incluirRT(v) {
      if (!v) {
        this.rtFlutuante = 0
      }
    },
    // Controla as formas de pagamento permitidas com base na selecionada
    indexPrimeiroPagamento(v) {
      if (v !== null && v !== undefined) {
        // Valida se a forma de pagamento é financiamento
        if (this.formaPagamentoSolar[v].descricao.toLowerCase().includes('financiamento')) {
          // Percorre para desativar os cartões
          for(let i = 0; i < this.formaPagamentoSolar.length; i++) {
            if (
              this.formaPagamentoSolar[i].descricao.toLowerCase().includes('cartão de crédito') ||
              this.formaPagamentoSolar[i].descricao.toLowerCase().includes('financiamento')
            ) {
              this.formaPagamentoSolar[i].disabled = true
            } else {
              this.formaPagamentoSolar[i].disabled = false
            }
          }

        // Se for cartão de crédito
        } else if (this.formaPagamentoSolar[v].descricao.toLowerCase().includes('cartão de crédito')) {
          // Percorre para desativar os financiamentos
          for(let i = 0; i < this.formaPagamentoSolar.length; i++) {
            if (this.formaPagamentoSolar[i].descricao.toLowerCase().includes('financiamento')) {
              this.formaPagamentoSolar[i].disabled = true
            } else {
              this.formaPagamentoSolar[i].disabled = false
            }
          }
        } else {
          // Ativa todos menos o que já foi escolhido
          for(let i = 0; i < this.formaPagamentoSolar.length; i++) {
            if (this.formaPagamentoSolar[i].descricao === this.formaPagamentoSolar[v].descricao) {
              this.formaPagamentoSolar[i].disabled = true
            } else {
              this.formaPagamentoSolar[i].disabled = false
            }
          }
        }

      // Caso remover a seleção do pagamento
      } else {
        // Desativa todos
        for(let i = 0; i < this.formaPagamentoSolar.length; i++) {
          this.formaPagamentoSolar[i].disabled = true
        }
      }

      this.indexPagamento = null
    },
    // Controla se possuirá mais de uma forma de pagamento
    moreThanOnePayment(v) {
      this.indexPagamento = null
      for(let i = 0; i < this.formaPagamentoSolar.length; i++) {
        this.formaPagamentoSolar[i].disabled = v ? true : false
      }
    },
    // Realiza a alteração e calculo do frete
    selectedAddress(v) {
      if (v && v.cep) {
        this.enderecoEntrega = v
        this.calcularFrete(v.cep)
      }
    },
    // Se o valor com juros for alterado realiza o reset da RT flutuante
    // com os novos parâmetros
    controleJurosCondicao(v) {
      // Atualiza o valor minimo da RT e o valor Máximo
      this.valorSemRT = v
      // Atualiza o valor atual da RT aplicada para 0
      this.rtFlutuante = 0
      this.vlNotaFlutuante = v
    },
    indexPagamento() {
      // Limpa a condição selecionada
      this.condicaoSelecionada = null
    },
    rtFlutuante() {
      this.vlNotaFlutuante =
        parseFloat((parseFloat(this.valorSemRT) + parseFloat(this.rtFlutuante)).toFixed(2))
    },
    vlNotaFlutuante() {
      this.rtFlutuante =
        parseFloat((parseFloat(this.vlNotaFlutuante) - parseFloat(this.valorSemRT)).toFixed(2))
    },
  },
  // VARIAVEIS COMPUTADAS (SE ATUALIZAM AUTOMÁTICAMENTE SE ALGUM PARÂMETRO FOR ALTERADO)
  computed: {
    valorSegundaFormaPagamentoOriginal() { // funcao original
      return parseFloat(
        (parseFloat(this.valorTotalNF) - parseFloat(this.valorPagamento)).toFixed(2)
      )
    },
    valorSegundaFormaPagamento() {
      //valor da 2 forma de pagto
      return parseFloat(
        //((parseFloat(this.valorTotal) - parseFloat(this.valorPagamento)) + this.jurosCondicao + this.rtFlutuante).toFixed(2)
        ((parseFloat(this.valorTotal) - parseFloat(this.valorPagamento)) + this.valorTotalComJuros + parseFloat(this.rtFlutuante)).toFixed(2)
      )
    },
    valorTotalNF() {
      console.log('valor total nota fiscal -------> ' + (parseFloat(this.valorTotal + this.jurosSobreNF + this.rtFlutuante + this.valorPagamento)));
      //console.log('this valorTotal ' + this.valorTotal);
      //console.log('this jurosSobreNF ' + this.jurosSobreNF);
      console.log('valor rtflutuante ' + this.rtFlutuante);
     
      let retornoTotalNf = this.valorTotal + this.jurosSobreNF + this.rtFlutuante;
      console.log('Valor slaSelecionado', this.slaSelecionado);
      console.log('Valor slaSelecionado', this.valorSemRT);

      if (
        this.moreThanOnePayment &&
        this.indexPagamento !== null &&
        this.indexPagamento !== undefined &&
        this.formaPagamentoSolar[this.indexPagamento].descricao.toLowerCase().includes('cartão de crédito')
      ) {
        // Valida se a condição foi selecionada também
        if (this.condicaoSelecionada && this.condicaoSelecionada !== null) {
          //console.log(this.condicaoSelecionada.descricao);
          if(this.condicaoSelecionada.descricao != '1x'){
            retornoTotalNf = this.valorTotal + this.jurosSobreNF + this.rtFlutuante + this.valorPagamento
          } else {
            retornoTotalNf = this.valorTotal + this.jurosSobreNF + this.rtFlutuante
          }         
          console.log('valor retorno Total NF ', retornoTotalNf);
          console.log('ValorPagamento ', this.valorPagamento);
          console.log('Valor slaSelecionado', this.slaSelecionado);
        }
      }
      return retornoTotalNf;
    },
    // Reliza o calculo do valor total sem o juros sobre a RT
    totalSemJurosSobreRT() {
      return this.valorTotal + this.jurosCondicao + this.rtFlutuante
    },
    // Realiza o controle se o juros da condição sofreu alteração
    controleJurosCondicao() {
      return this.valorTotal + this.jurosCondicao
    },
    // Realiza o calculo do valor total dos descontos
    valorTotalDescontos() {
      let value = 0
      value += parseFloat(this.descontoValorNegociado)

      value += parseFloat(this.descontoFormaPagamento)
      return parseFloat(value.toFixed(2))
    },
    // Raliza o calculo do valor total da NF
    valorTotal() {
      let value = 0
      // Total carrinho
      value += parseFloat(this.totalCarrinho)
      // Frete
      value += this.slaSelecionado && this.slaSelecionado.preco ?
        parseFloat(this.slaSelecionado.preco) :
        0
      // Acrescimo Negociado
      value += parseFloat(this.acrescimoValorNegociado)
      // Desconto negociado
      value -= parseFloat(this.descontoValorNegociado)
      // Desconto da forma de pagamento
      value -= parseFloat(this.descontoFormaPagamento)
      // Retorna
      return parseFloat(value.toFixed(2))
    },
// Calcula o valor de desconto negociado em cima do valor dos produtos do carrinho
    descontoValorNegociado() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.descontoVNegociado = 0;
      if (
        parseFloat(this.valorNegociado) !== 0 &&
        parseFloat(this.valorNegociado) < parseFloat(this.totalCarrinho)
      ) {

        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.descontoVNegociado = (parseFloat(this.totalCarrinho) - parseFloat(this.valorNegociado) - parseFloat(this.descontoFormaPagamento)).toFixed(2);
        return parseFloat(
          (
            parseFloat(this.totalCarrinho) -
            parseFloat(this.valorNegociado) -
            // Retira o desconto já dado pela forma de pagamento
            parseFloat(this.descontoFormaPagamento)
          ).toFixed(2)
        )
      }
      return 0
    },
    // Calcula o acrescimo do valor negociado em cima do valor dos produtos do carrinho
    acrescimoValorNegociado() {
      if (parseFloat(this.valorNegociado) > parseFloat(this.totalCarrinho)) {
        return parseFloat(
          (parseFloat(this.valorNegociado) - parseFloat(this.totalCarrinho)).toFixed(2)
        )
      }
      return 0
    },
    // Calcula o desconto da forma de pagamento selecionada
    descontoFormaPagamento() {
      //console.log('entrou aqui 1')
      //eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.descontoFPagamento = 0;

      // Valida se possui mais de uma forma de pagamento
      if (
        this.moreThanOnePayment &&
        this.indexPagamento !== null &&
        this.indexPagamento !== undefined &&
        this.indexPrimeiroPagamento !== null &&
        this.indexPrimeiroPagamento !== undefined
      ) {
        // Valida se possuem desconto
        if (
          this.formaPagamentoSolar[this.indexPagamento].condicoesDePagamento.length === 1 &&
          this.formaPagamentoSolar[this.indexPrimeiroPagamento].condicoesDePagamento.length === 1
        ) {
          console.log('entrou aqui')
          // Monta o array para controle de pior cenário
          let segundoPagamento = this.formaPagamentoSolar[this.indexPagamento].condicoesDePagamento[0].descontoMaximo;
          let primeiroPagamento = this.formaPagamentoSolar[this.indexPrimeiroPagamento].condicoesDePagamento[0].descontoMaximo
          segundoPagamento = segundoPagamento == undefined ? 0 : segundoPagamento;
          primeiroPagamento = primeiroPagamento == undefined ? 0 : primeiroPagamento;
          //console.log('segundoPagamento', segundoPagamento)
          //console.log('primeiroPagamento', primeiroPagamento)
          // let arrayDescontos = [
          //   segundoPagamento,
          //   primeiroPagamento
          //   // this.formaPagamentoSolar[this.indexPagamento].condicoesDePagamento[0].descontoMaximo,
          //   // this.formaPagamentoSolar[this.indexPrimeiroPagamento].condicoesDePagamento[0].descontoMaximo
          // ]

          let percentualDesconto = 0;
          if(segundoPagamento > primeiroPagamento){
            percentualDesconto = primeiroPagamento;
          }
          else{
            percentualDesconto = segundoPagamento;
          }

          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.descontoFPagamento = (this.totalCarrinho * (percentualDesconto / 100)).toFixed(2);
          //console.log(this.descontoFPagamento);
          // arrayDescontos = arrayDescontos.filter(a => a && a !== null && a !== undefined)
          // console.log(JSON.stringify(arrayDescontos))
          // console.log((Math.min(...arrayDescontos)))
          // Pega o menor valor de desconto e atribui a porcentagem
          // return this.totalCarrinho * (Math.min(...arrayDescontos) / 100)

          return this.totalCarrinho * (percentualDesconto / 100)
        }
      // Calcula o desconto da forma de pagamento
      } else if (
        !this.moreThanOnePayment &&
        this.indexPagamento !== null &&
        this.indexPagamento !== undefined &&
        this.formaPagamentoSolar.length > 0 &&
        this.formaPagamentoSolar[this.indexPagamento].condicoesDePagamento.length === 1
      ) {
        console.log('Calcula o desconto da forma de pagamento');
        // Recupera o desconto máximo da forma de pagamento
        const descontoMaximo = this.formaPagamentoSolar[this.indexPagamento].condicoesDePagamento[0].descontoMaximo;
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.descontoFPagamento =  parseFloat(this.totalCarrinho) * parseFloat(descontoMaximo / 100);
        return this.totalCarrinho * (descontoMaximo / 100)
      }
      return 0
    },
    // Realiza a validação de bloqueios (Valor minimo e valor Maximo)
    bloqueios() {
      let arrayControle = []
      // Validações de Bloqueios
      if (this.valorNegociado > 0 || this.valorNegociado < 0) {
        // Calcula o limite máximo de desconto negociado em % (não está sendo arredondado para não passar os quebrados)
        let porcentagemDesconto = parseFloat(
          (100 - ((this.totalCarrinho - this.descontoValorNegociado) / this.totalCarrinho) * 100)
        )

        // Se a porcentagem total do desconto for maior que 2
        if (porcentagemDesconto > 2) {
          // Acrescenta o bloqueio de Desconto acima do permitido
          arrayControle.push({
            description:
              "DESCONTO ACIMA DO PERMITIDO SOLAR - " +
              porcentagemDesconto.toFixed(2) +
              "%",
          });
        }


        // Calcula o valor negociado máximo permitido (+ 50% do valor do carrinho - SOMENTE PRODUTOS)
        let valorLimite =
          parseFloat(this.totalCarrinho) +
          parseFloat(this.totalCarrinho) * 0.5;
        // Se o valor negociado for maior que o valor limite
        if (this.valorNegociado > valorLimite) {
          // Insere o bloqueio de valor acima do esperado
          arrayControle.push({
            description: "VALOR NEGOCIADO ACIMA DO ESPERADO SOLAR - 50%",
          });
        }
      }
      let rtLimite =
      parseFloat(this.valorSemRT) * 0.5
      if (this.rtFlutuante > rtLimite){
         arrayControle.push({
            description: "VALOR RT SUJEITO A APROVAÇÃO - 50%",
          });
      }
        //console.log('array forma de pagamento', this.formaPagamentoSolar);

          if(this.formaPagamentoSolar[this.indexPrimeiroPagamento] != undefined){
            if(this.formaPagamentoSolar[this.indexPrimeiroPagamento]['descricao'] == 'FINANCIAMENTO' || this.formaPagamentoSolar[this.indexPrimeiroPagamento]['descricao'] == 'FINANCIAMENTO SANTANDER' || this.formaPagamentoSolar[this.indexPrimeiroPagamento]['descricao'] == 'FINANCIAMENTO BV'){
              arrayControle.push({ description: "BLOQUEIO GERAL FINANCIAMENTO - 0%"});
            }
            if(this.formaPagamentoSolar[this.indexPrimeiroPagamento]['descricao'] == 'BOLETO PARCELADO'){
              arrayControle.push({ description: "BLOQUEIO GERAL PAGAMENTO - 0%"});
            }
          } 
          
          if(this.formaPagamentoSolar[this.indexPagamento] != undefined){ 
            if(this.formaPagamentoSolar[this.indexPagamento]['descricao'] == 'FINANCIAMENTO' || this.formaPagamentoSolar[this.indexPagamento]['descricao'] == 'FINANCIAMENTO SANTANDER' || this.formaPagamentoSolar[this.indexPagamento]['descricao'] == 'FINANCIAMENTO BV' ){
              arrayControle.push({ description: "BLOQUEIO GERAL FINANCIAMENTO - 0%"});
            }
            if(this.formaPagamentoSolar[this.indexPagamento]['descricao'] == 'BOLETO PARCELADO'){
              arrayControle.push({ description: "BLOQUEIO GERAL PAGAMENTO - 0%"});
            }
          }

        console.log( 'primeiro pagto', this.formaPagamentoSolar[this.indexPrimeiroPagamento]);
        console.log( 'segundo pagto', this.formaPagamentoSolar[this.indexPagamento]);
        //verifica se é parceiro
        //console.log('É PARCEIRO ', localStorage.getItem("perfilParceiro"));
        // console.log('indexPrimeiroPagto' , this.formaPagamentoSolar[this.indexPagamento].descricao.toLowerCase().includes('cartão de crédito'));
        //se parceiro inclui bloqueio parceiro
        if(this.isPartner === true){
          arrayControle.push({ description: "BLOQUEIO GERAL PARCEIRO - 0%"});
        }
      
        console.log('arrayControle', arrayControle);
      return arrayControle
    },
    // Calcula o Juros sobre a NF
    jurosSobreNF() {
      let juros = 0

      // Regra de calculo do juros sobre a nota quando há mais de um pagamento
      if (
        this.moreThanOnePayment &&
        this.indexPagamento !== null &&
        this.indexPagamento !== undefined &&
        this.indexPrimeiroPagamento !== null &&
        this.indexPrimeiroPagamento !== undefined &&
        this.condicaoSelecionada
      ) {

        // Array de controle para encontrar o pior cenário de juros
        let arrayControle = [
          this.condicaoSelecionada.descontoMaximo
        ]

        if (this.condicaoPrimeiroPagamento) {
          arrayControle.push(this.condicaoPrimeiroPagamento.descontoMaximo)
        }
        arrayControle = arrayControle.filter(a => a !== null && a !== undefined && a <= 0)

        // Pega o maior juros que houver (juros vem negativo por isso é MIN (não ta errado kkkk))
        let porcentagemJuros = Math.min(...arrayControle)

        // Se for cartão de crédito calcula as parcelas
        if (porcentagemJuros && this.formaPagamentoSolar[this.indexPagamento].descricao.toLowerCase().includes('cartão de crédito')) {
          let vlParcela = parseFloat(
            this.calculaJurosParcelaValor(
              this.condicaoSelecionada.id,
              porcentagemJuros,
              (parseFloat(this.totalSemJurosSobreRT) - parseFloat(this.jurosCondicao))
            ).toFixed(2)
          )
					let valorRT = parseFloat(this.rtFlutuante);
					if(this.condicaoSelecionada.id != 1){
						valorRT = 0;
					}
          this.atualizaValorParcelaCalculada(vlParcela, valorRT)

          // Realiza o calculo da diferença entre o valor total e o juros total
          juros = parseFloat(
            (
              (vlParcela * this.condicaoSelecionada.id) -
              (parseFloat(this.totalSemJurosSobreRT) - parseFloat(this.jurosCondicao))
            ).toFixed(2)
          )
        } else {
          juros = 0
        }

      // Calcula o Juros sobre a NF quando não ha dois pagamentos
      } else if (
        !this.moreThanOnePayment &&
        this.jurosCondicao > 0 &&
        this.indexPagamento !== null &&
        this.indexPagamento !== undefined &&
        this.formaPagamentoSolar[this.indexPagamento].descricao.toLowerCase().includes('cartão de crédito')
      ) {
        // Valida se a condição foi selecionada também
        if (this.condicaoSelecionada && this.condicaoSelecionada !== null) {
          // Realiza o calculo da parcela (Somente aplicado no valor)
          let vlParcela = parseFloat(
            this.calculaJurosParcelaValor(
              this.condicaoSelecionada.id,
              this.condicaoSelecionada.descontoMaximo,
              (parseFloat(this.totalSemJurosSobreRT) - parseFloat(this.jurosCondicao))
            ).toFixed(2)
          )
					let valorRT = this.rtFlutuante;
					if(this.condicaoSelecionada.id != 1){
						valorRT = 0;
					}
          this.atualizaValorParcelaCalculada(vlParcela, valorRT)

          // Realiza o calculo da diferença entre o valor total e o juros total
          juros = parseFloat(
            (
              (vlParcela * this.condicaoSelecionada.id) - (parseFloat(this.totalSemJurosSobreRT) - parseFloat(this.jurosCondicao))
            ).toFixed(2)
          )
        }
      }
      return juros
    },
    // Realiza o calculo dos juros sobre a forma de pagamento selecionada
    jurosCondicao() {
      console.log('CALCULA JUROS CONDICAO --------------')
      let juros = 0
      if (
        this.moreThanOnePayment &&
        this.indexPagamento !== null &&
        this.indexPagamento !== undefined &&
        this.indexPrimeiroPagamento !== null &&
        this.indexPrimeiroPagamento !== undefined &&
        this.condicaoSelecionada
      ) {
        // Array de controle para encontrar o pior cenário de juros
        let arrayControle = [
          this.condicaoSelecionada.descontoMaximo
        ]

        if (this.condicaoPrimeiroPagamento) {
          arrayControle.push(this.condicaoPrimeiroPagamento.descontoMaximo)
        }
        arrayControle = arrayControle.filter(a => a !== null && a !== undefined && a <= 0)

        // Pega o maior juros que houver (juros vem negativo por isso é MIN (não ta errado kkkk))
        let porcentagemJuros = Math.min(...arrayControle)
        let valorRT = parseFloat(this.rtFlutuante);

        // Se for cartão de crédito calcula as parcelas
        if (porcentagemJuros && this.formaPagamentoSolar[this.indexPagamento].descricao.toLowerCase().includes('cartão de crédito')) {
          console.log('valorrrrrrrrrrrrrr da rt', this.rtFlutuante)
                   
          let vlParcela = parseFloat(
            this.calculaJurosParcelaValor(
              this.condicaoSelecionada.id,
              porcentagemJuros,
              parseFloat(this.valorTotal)  
            ).toFixed(2)
          )

          let valorRT = parseFloat(this.rtFlutuante);
          // if(this.condicaoSelecionada.id != 1){
					// 	valorRT = 0;
					// }
        
          this.atualizaValorParcelaCalculada(vlParcela, valorRT)

          juros = parseFloat(
            ((vlParcela * this.condicaoSelecionada.id) - (this.valorTotal - this.valorPagamento)).toFixed(2)
          )
          //let somaNovoJuros = (parseFloat(this.valorTotal) + valorRT) - (vlParcela * this.condicaoSelecionada.id);
          
          let somaNovoJuros = (((parseFloat(this.valorTotal) + valorRT) - this.valorPagamento) );
          console.log('somaNovoJuros ----------->', somaNovoJuros)
          console.log('jurosCondicao valorTotalcomJuros',  this.valorTotalComJuros)
          console.log('jurosCondicao valorRT -----------> ' , valorRT);
          console.log('jurosCondicao ValorTotal --------> ' , this.valorTotal);
          console.log('jurosCondicao valorPagamento --------> ' , this.valorPagamento);          
          console.log('jurosCondicao condicao selecionada --------> ' , this.condicaoSelecionada.id);
          console.log('jurosCondicao Valor parcela --------> ' , vlParcela);
          console.log("jurosCondicao FIM 2 PAGTY-------> ", juros );

          console.log('passou 987987987')
        } else {
          console.log('passou 1234059494')
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.valorTotalComJuros = 0;
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.valorParcelaCartao =  parseFloat(this.valorTotal) + valorRT - this.valorPagamento;
          console.log(this.valorParcelaCartao)
          console.log("jurosCondicao ZERO-------> ", juros );
          juros = 0
        }

      // Valida se o juros será calculado como cartão de crédito
      } else if (
        !this.moreThanOnePayment &&
        this.indexPagamento !== null &&
        this.indexPagamento !== undefined &&
        this.formaPagamentoSolar[this.indexPagamento].descricao.toLowerCase().includes('cartão de crédito')
      ) {
        // Valida se a condição foi selecionada também
        if (this.condicaoSelecionada && this.condicaoSelecionada !== null) {
          console.log('passa se 1 pagamento')

          // Realiza o calculo da parcela (Somente aplicado no valor)
          let vlParcela = parseFloat(
            this.calculaJurosParcelaValor(
              this.condicaoSelecionada.id,
              this.condicaoSelecionada.descontoMaximo,
              parseFloat(this.valorTotal)
            ).toFixed(2)
          )
					let valorRT = this.rtFlutuante;
					// if(this.condicaoSelecionada.id != 1){
					// 	valorRT = 0;
					// }
          
          this.atualizaValorParcelaCalculada(vlParcela, valorRT)

          // Realiza o calculo da diferença entre o valor total e o juros total
          juros = parseFloat(
            ((vlParcela * this.condicaoSelecionada.id) - this.valorTotal).toFixed(2)
          )
          console.log('se uma parcela recalculo valor parcela', vlParcela);
          console.log('se uma parcela recalculo ', valorRT);
          console.log('se uma parcela recalculo ', juros);
           
           if(this.condicaoSelecionada.id == 1){
           // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.valorParcelaCartao =  (parseFloat(this.valorTotal) + valorRT) - juros;
           } else {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.valorParcelaCartao =  (parseFloat(this.valorTotal) + valorRT + this.valorTotalComJuros) / this.condicaoSelecionada.id;
           }
           
           console.log(this.valorParcelaCartao)

        }
      }
    
      return juros
    },
  },
  methods: {
		async validaProfitz(){
			console.log(localStorage.getItem("perfilParceiro"));
			if(localStorage.getItem("perfilParceiro") == "false"){
				if(this.parceiroSelecionado){
					const saldoProfitz = await axios.get(`https://leverosintegra.dev.br/api/bcdigital/registerOld/${this.parceiroSelecionado.cnpj}`)
					if(saldoProfitz.data.card_balance != undefined){
						this.valorProfitz = parseFloat(saldoProfitz.data.card_balance) / 100
						this.cnpjProfitz = this.parceiroSelecionado.cnpj;
					}
					else{
						this.valorProfitz = 0;
					}
				}
			}
		},
    atualizaValorParcelaCalculada(parcela, rt = 0) {
      this.valorParcelaCalculada = parcela + rt
    },

    salvaNovoEndereco() {
      if (
        this.novoEndereco.cep &&
        this.novoEndereco.logradouro &&
        this.novoEndereco.nrresidencia &&
        this.novoEndereco.bairro &&
        this.novoEndereco.cidade &&
        this.novoEndereco.uf
      ) {
        let endereco =  Object.assign({}, this.novoEndereco);
        endereco.bairro = endereco.bairro.toUpperCase();
        endereco.logradouro = endereco.logradouro.toUpperCase();
        endereco.nrresidencia = endereco.nrresidencia.toUpperCase();
        endereco.complemento = endereco.complemento ? endereco.complemento.toUpperCase() : null;
        endereco.cidade = endereco.cidade.toUpperCase();
        endereco.Pais = 1;
        this.infos.endereco.push(endereco);
        axios({
          method: "post",
          data: {
            Dados: this.infos
          },
          url: `https://www.leverosintegra.com.br/Map/api/Client?token=${this.token}`,
        }).then(res => {
          this.loading = false;
          if (res.data) {
            alert("Novo endereço salvo com sucesso!")
            this.novoEndereco = cleanNewAddress()
          }
        }).catch(err => {
          this.loading = false;
          console.log(err);
        })
      } else {
        alert("Não foi possivel inserir novo endereço! Verifique os dados!")
      }
    },

    rtFlutuanteBlur() {
      if (this.rtFlutuante > this.valorSemRT * 0.8 || this.rtFlutuante < 0) {
        this.rtFlutuante = 0;
      }
    },

    vlNotaFlutuanteBlur() {
      if (
        this.vlNotaFlutuante > this.valorSemRT + this.valorSemRT * 0.8 ||
        this.vlNotaFlutuante < this.valorSemRT
      ) {
        this.vlNotaFlutuante = this.valorSemRT;
        this.rtFlutuante = 0;
      }
    },

    setEndereco(dados) {
      this.enderecoEntrega = dados;
      this.calcularFrete(dados.cep);
    },

    buscaCEP() {
      axios
        .get(`https://viacep.com.br/ws/${this.novoEndereco.cep}/json/`)
        .then((res) => {
          let Endereco = res.data;
          this.novoEndereco.logradouro = Endereco.logradouro;
          this.novoEndereco.cidade = Endereco.localidade;
          this.novoEndereco.uf = Endereco.uf;
          this.novoEndereco.bairro = Endereco.bairro;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    calculaJurosParcelaValor(qtdParcela, taxa, valor) {
     // console.log('calcula juros valor parcela -------')
      if (taxa && qtdParcela != 1) {
        let valorRTFlutuante = parseFloat(this.rtFlutuante);
        var valorFinanciado = valor - this.valorPagamento;
        let __valorTotalTeste = valorRTFlutuante + valorFinanciado;
        var parcelas = qtdParcela;
        var juros = -taxa / 100; //ao mês
        var cf = juros/(1 - (1 / Math.pow(1 + juros, parcelas)));
        var valorDaParcela = cf * valorFinanciado;
        var __valorDaParcela = cf * __valorTotalTeste;
        console.log('qtdParcela ' + qtdParcela);
        console.log('taxa ' + taxa);
        console.log('VALOR -------> ' + valor);
        console.log('valor CF--> ' + cf);       
        console.log('calcula juros VALOR PARCELA Anterior' + valorDaParcela);
        console.log('calcula juros VALOR PARCELA ' + __valorDaParcela);
        console.log('Valor já pago ->' + this.valorPagamento);
        //armazena valor da parcela
        // this.valorParcelaCartao = valorDaParcela;
        this.valorParcelaCartao = __valorDaParcela;
        //juros parcela cartao
        // this.jurosParcelaCartao = valorDaParcela * qtdParcela;
        this.jurosParcelaCartao = __valorDaParcela * qtdParcela;
        console.log('RRRRRRRRRRRTTTTTTTTTTTTTTTTTT: ', this.rtFlutuante)
        console.log('RRRRRRRRRRRTTTTTTTTTTTTTTTTTT: ', __valorTotalTeste)

        console.log('total de parcela + juros ---> ', this.jurosParcelaCartao)
        //if(qtdParcela != 1){

          this.valorTotalComJuros = this.jurosParcelaCartao - __valorTotalTeste
        // } else { 
        //   this.valorTotalComJuros = 0
        // }

        return valorDaParcela;
        // return __valorDaParcela
      } else {
        return valor;
      }
    },
    calculaJurosParcelaValor1(qtdParcela, taxa, valor) {
      if (taxa) {
        taxa = -taxa / 100;
        var parte1 = Math.pow(1 + taxa, qtdParcela) * taxa;
        var parte2 = Math.pow(1 + taxa, qtdParcela) - 1;
        var parte3 = parte1 / parte2;
        var valorParcela = valor * parte3;
        return valorParcela;
      } else {
        return valor;
      }
    },

    async finalizaCompra() {
      try {
        // Recupera os dados do usuário logado
        let dados = JSON.parse(localStorage.getItem("login"));
        // Recupera canal logado
        let escritorio = JSON.parse(localStorage.getItem("saleChannel"));

        // Inicializa as váriaveis
        let vendedorResponsavel;
        let codigoParceiro;
        if (dados.codVendedor.toString().indexOf("567890") >= 0) {
          vendedorResponsavel = dados.codVendedor;
          codigoParceiro = this.parceiroSelecionado
            ? this.parceiroSelecionado.cdPessoa
            : null;
        } else {
          vendedorResponsavel = this.parceiroSelecionado.codigoVendedorResponsavel;
          codigoParceiro = dados.codVendedor;
        }

        // Recupera os dados do canal de venda
        let saleChannel = dados.canalvendas.find((sale) => {
          if (sale.IdCanal == escritorio) {
            return sale;
          }
        });

        // Valida se o cliente foi pesquisado
        if (!this.cpfcnpj) {
          this.dialogActionController(
            true,
            `Atenção!`,
            `Informe o cliente para prosseguir!`,
            () => {
              this.dialog.active = false
            }
          )
          return;
        }
        if (!this.responsavel.nome) {
          this.dialogActionController(
            true,
            `Atenção!`,
            `Preencha o nome do responsável pelo recebimento para prosseguir!`,
            () => {
              this.dialog.active = false
            }
          )
          return;
        }
        if (!this.responsavel.telefone) {
          this.dialogActionController(
            true,
            `Atenção!`,
            `Preencha o telefone do responsável pelo recebimento para prosseguir!`,
            () => {
              this.dialog.active = false
            }
          )
          return;
        }
        // Valida se foi escolhido o endereço de entrega
        if (this.enderecoEntrega == null) {
          this.dialogActionController(
            true,
            `Atenção!`,
            `Selecione o endereço para prosseguir!`,
            () => {
              this.dialog.active = false
            }
          )
          return;
        }
        // Valida se foi escolhido o tipo de entrega
        // if (this.slaSelecionado == null) {
        //   this.dialogActionController(
        //     true,
        //     `Atenção!`,
        //     `Selecione o tipo de entrega para prosseguir!`,
        //     () => {
        //       this.dialog.active = false
        //     }
        //   )
        //   return;
        // }

        // Inicializa a váriavel com o tipo de pagamento e condição
        let sendPagamento = [];

        // Se possuir mais de uma forma de pagamento
        if (this.moreThanOnePayment) {
          // Valida se a forma de pagamento foi escolhida
          if (this.indexPrimeiroPagamento === null || this.indexPrimeiroPagamento === undefined) {
            this.dialogActionController(
              true,
              `Atenção!`,
              `Selecione a 1º forma de pagamento para prosseguir!`,
              () => {
                this.dialog.active = false
              }
            )
            return;
          }
          // Valida se a condição de pagamento foi escolhida
          if (
            this.formaPagamentoSolar[this.indexPrimeiroPagamento].condicoesDePagamento.length > 1 &&
            !this.condicaoPrimeiroPagamento
          ) {
            this.dialogActionController(
              true,
              `Atenção!`,
              `Selecione a 1º condição de pagamento para prosseguir!`,
              () => {
                this.dialog.active = false
              }
            )
            return;
          }

          // Valida se o pagamento está maior do que o valor minimo aceito
          if (parseFloat(this.valorPagamento.toFixed(2)) < 2) {
            this.dialogActionController(
              true,
              `Atenção!`,
              `Valor da 1º forma de pagamento incorreto! (O valor não pode ser R$ 2,00)`,
              () => {
                this.dialog.active = false
              }
            )
            return;
          }

          // Inclui a forma de pagamento no Array
          sendPagamento.push({
            descricao: this.formaPagamentoSolar[this.indexPrimeiroPagamento].descricao,
            condicao: this.condicaoPrimeiroPagamento ? this.condicaoPrimeiroPagamento.id : null,
            // Valor de pagamento inserido para a primeira forma de pagamento
            valor: parseFloat(this.valorPagamento.toFixed(2))
          })
        }

        // Valida se a forma de pagamento foi escolhida
        if (this.indexPagamento === null || this.indexPagamento === undefined) {
          this.dialogActionController(
            true,
            `Atenção!`,
            this.moreThanOnePayment ?
            `Selecione a 2º forma de pagamento para prosseguir!` :
            `Selecione a forma de pagamento para prosseguir!`,
            () => {
              this.dialog.active = false
            }
          )
          return;
        }
        // Valida se a condição de pagamento foi escolhida
        if (
          this.formaPagamentoSolar[this.indexPagamento].condicoesDePagamento.length > 1 &&
          !this.condicaoSelecionada
        ) {
          this.dialogActionController(
            true,
            `Atenção!`,
            this.moreThanOnePayment ?
            `Selecione a 2º condição de pagamento para prosseguir!` :
            `Selecione a condição de pagamento para prosseguir!`,
            () => {
              this.dialog.active = false
            }
          )
          return;
        }

        // Verifica se possui mais de um pagamento
        if (this.moreThanOnePayment) {
          // Valida se o pagamento está maior do que o valor minimo aceito
          if (parseFloat(this.valorSegundaFormaPagamento.toFixed(2)) < 2) {
            this.dialogActionController(
              true,
              `Atenção!`,
              `Valor da 2º forma de pagamento incorreto! (O valor não pode ser R$ 2,00)`,
              () => {
                this.dialog.active = false
              }
            )
            return;
          }
        }

        sendPagamento.push({
          descricao: this.formaPagamentoSolar[this.indexPagamento].descricao,
          condicao: this.condicaoSelecionada ? this.condicaoSelecionada.id : null,
          // Valida o valor
          valor: this.moreThanOnePayment ?
            // Se possuir mais de um pagamento pega o valor do pagamento
            parseFloat(this.valorSegundaFormaPagamento.toFixed(2)) :
            // Se não pega o valor total do pedido
            parseFloat(this.valorTotalNF.toFixed(2))
        })


        if(sendPagamento.length> 0){
          let valorUsoProfitz = 0;
          for(let i = 0; i < sendPagamento.length; i++){
            if(sendPagamento[i].descricao == "PROFITZ"){
              valorUsoProfitz += parseFloat(sendPagamento[i].valor);
            }
          }
          if(valorUsoProfitz > 0){
            if(valorUsoProfitz > this.valorProfitz){
              this.dialogActionController(
                    true,
                    `Atenção`,
                    `Saldo de Profitz é insuficiente, você possui ${this.valorProfitz} e tentou utilizar ${valorUsoProfitz}`,
                    () => {
                      this.dialog.active = false
                    }
                  )
                  return;
            }
            let getOrderNumber = await axios.get('https://www.leverosintegra.com.br/map/api/orders');
              // console.log(getOrderNumber.data)
              let bodyToUpadateProfitz = {
                    "cnpj": `${this.cnpjProfitz}`,
                    "value": -(valorUsoProfitz * 100),
                    "validAt": "2023-06-30",
                    "description": `Resgatado no Pedido de Venda ${getOrderNumber.data}`,
                    "origem": "Resgate"
              }
              let comitProfitz = await axios({
                method: 'post',
                url: 'https://leverosintegra.dev.br/api/bcdigital/credit',
                data: bodyToUpadateProfitz,
                headers: {
                  token: `39ba2070-c234-11ec-8d18-f56907899f1a`,
                },
              }).then(res => {
                return res
              }).catch(err => {
                return err
              })
              console.log(comitProfitz.data)
              if(comitProfitz.data == undefined){
                if(comitProfitz.response.status){
                  this.dialogActionController(
                    true,
                    `Falha capturar Profitz`,
                    comitProfitz.response.data,
                    () => {
                      this.dialog.active = false
                    }
                  )
                  return;

                }
              }
          }
        }
        console.log('bloqueios', this.bloqueios);

        let dadosPedido = {
          orcamento: false,
          vendedor: vendedorResponsavel,
          acessParceiro: localStorage.getItem("perfilParceiro"),
          Ip: localStorage.getItem("ip"),
          prazoMax: this.carrinho[0].prazoMaior,
          // Valor total do pedido
          valorTotal: this.valorTotalNF,
          // Valor total dos descontos
          valorDesconto: this.valorTotalDescontos,
          descontoFormaPagamento : parseFloat(this.descontoFPagamento),
          descontoPedido: parseFloat(this.descontoVNegociado),
          usuario: this.usuarioLogado,
          deposito: "0001",
          parceiro: {
            cdPessoa: codigoParceiro,
          },
          canalVendas: {
            saleschannel: saleChannel.NomeCanal,
            id: saleChannel.IdCanal,
          },
          observacoesPedido:
            (this.observacoesPedido ? this.observacoesPedido : '') +
            ` ${this.responsavel.nome ? this.responsavel.nome : ''} ${this.responsavel.telefone ? this.responsavel.telefone : ''}`,
          cpfCnpj: this.infos.cpfcnpj,
          logradouro: this.enderecoEntrega.logradouro,
          numero: this.enderecoEntrega.nrresidencia,
          cep: this.enderecoEntrega.cep,
          Carrinho: [],
          Pagamento: sendPagamento,
          rt: 0,
          zrts: parseFloat(this.rtFlutuante),
          Frete: {
            Expedicao: this.slaSelecionado.expedicao,
            prazo: this.slaSelecionado.sla,
            tipoFrete: this.slaSelecionado.tipo,
            valorFrete: this.slaSelecionado.preco,
            dataAgendada: this.dataEscolhida
              ? this.dataEscolhida.startDateUtc
              : null,
            agendadaInicio: this.dataEscolhida
              ? this.dataEscolhida.startDateUtc
              : null,
            agendadaFim: this.dataEscolhida
              ? this.dataEscolhida.endDateUtc
              : null,
            valorOriginal: this.slaSelecionado.preco,
          },
          // Array de bloqueios
          Bloqueios: this.bloqueios,
          isSolar: true,
        };

        // Encontra a diferença entre o valor total da NF (tirando o frete) e o valor do carrinho
        let diferenca = parseFloat(
          ((parseFloat(this.valorTotalNF) - parseFloat(this.slaSelecionado.preco)) -
          parseFloat(this.totalCarrinho)).toFixed(2)
        )
        // Atualiza/Padroniza dados do carrinho

       this.carrinho.forEach((e) => {


          let infoCarrinho = {
            Sku: e.sku,
            Descricao: e.nomeItem,
            ValorUnitario: parseFloat(parseFloat(e.valor).toFixed(2)),
            ValorTotal: e.valor,
            Quantidade: e.quantidade,
            Expedicao: this.slaSelecionado.expedicao,
            Prazo: e.sla,
            QuantidadeDisponivel: e.estoque,
            arrayItensSolar: e.arrayItensSolar,
            // Calcula o percentual da diferença de cada item
            percentual: parseFloat(
              (diferenca * (parseFloat(e.valor) / this.totalCarrinho)).toFixed(2)
            ),
          }
          // Insere no array
          dadosPedido.Carrinho.push(infoCarrinho)
        })

        // Realiza o envio dos dados para a criação do pedido
        console.log('dados do pedido', dadosPedido);

        let criarPedido = await axios({
          method: "post",
          //url: `http://localhost:54015/Api/Orders?token=${this.token}`,
          url: `https://www.leverosintegra.com.br/Map/Api/Orders?token=${this.token}`,
          data: dadosPedido,
        });
        if (criarPedido.status == 201) {
          localStorage.removeItem("carrinho");
          window.location.href = `/panel/orders/DetailsOrder?Pedido=${
            criarPedido.data.split("nº ")[1]
          }`;
        } else {
          alert(criarPedido.message);
        }

      } catch (e) {
        console.log(e);
        if (e.response && e.response.status == 401) {
          alert(
            "Seu login expirou ou você efetuou acesso em outra máquina. Realize o login novamente!"
          );
        } else {
          alert(e);
        }
      }
    },

    dialogActionController(
      active = false,
      title = null,
      message = null,
      actionFunction = null,
      denyAction = false
    ) {
      this.dialog.active = active
      this.dialog.title = title
      this.dialog.message = message
      this.dialog.actionFunction = actionFunction
      this.dialog.denyAction = denyAction
    },

    selecionaSLA(sla) {
      this.slaSelecionado = sla;
      if (this.slaSelecionado.datasAgendada) {
        this.dataSelecionada = this.slaSelecionado.datasAgendada
      }
    },

    productDetails(sku, preco) {
      localStorage.setItem(
        "precoDetails",
        JSON.stringify({ preco: preco, sku: sku })
      );
      window.location.href = `../details?sku=${sku}`;
    },

    async calcularFrete(cep) {
      this.loader = true;
      if (cep != null) {
        if (cep.length == 9 || cep.length == 8) {
          let items = [];
          let escritorioVenda = localStorage.getItem("saleChannel");
          let carrinho = JSON.parse(localStorage.getItem("carrinho"));
          carrinho.forEach(function (e) {
            let _items = {
              idSku: parseFloat(e.sku),
              quantidade: parseFloat(e.quantidade),
              price: parseFloat(e.valor) * parseFloat(e.quantidade),
            };
            items.push(_items);
          });
          let body = {
            location: {
              zipCode: cep.replace("-", ""),
            },
            saleschannel: escritorioVenda,
            items: items,
          };
          let simularFrete = await axios({
            method: "post",
            data: body,
            url: "https://www.leverosintegra.com.br/Map/api/ShippingSimulation/V2",
          }).then((res) => {
            return res.data;
          });
          this.loader = false;
          let sla = [];
          if (simularFrete.freightSimulated.length > 0) {
            simularFrete.freightSimulated[0].slaResponseFreightSimulated.forEach(
              function (frete) {
                let pushSla = true;
                let _frete = {
                  preco:
                    frete.listPrice < frete.minimum_MoneyCost
                      ? frete.minimum_MoneyCost
                      : frete.listPrice,
                  expedicao: frete.wareHouseName2,
                  sla: frete.totalTime,
                  tipo: frete.slaType,
                  descricao: frete.slaTypeName,
                  datasAgendada: frete.deliveryWindows,
                  textoFrete:
                    frete.slaTypeName !== "Agendada"
                      ? `${frete.slaType} - R$ ${(frete.listPrice <
                        frete.minimum_MoneyCost
                          ? frete.minimum_MoneyCost
                          : frete.listPrice
                        )
                          .toFixed(2)
                          .toString()
                          .replace(".", ",")} (Entrega em até ${
                          frete.totalTime
                        } dias úteis)`
                      : `${frete.slaType} - R$ ${(frete.listPrice <
                        frete.minimum_MoneyCost
                          ? frete.minimum_MoneyCost
                          : frete.listPrice
                        )
                          .toFixed(2)
                          .toString()
                          .replace(".", ",")} (Verificar datas disponíveis)`,
                };
                if (sla.length == 0) {
                  pushSla = true;
                } else if (sla.find((x) => x.tipo == frete.slaType) != null) {
                  pushSla = false;
                }
                //Valida se Todos os produtos são atendidos pelo SLA disposto
                carrinho.forEach(function (c) {
                  let slaCart =
                    simularFrete.freightSimulated[0].slaResponseFreightSimulated.find(
                      (x) => x.itemId == c.sku && x.slaType == _frete.tipo
                    );
                  if (slaCart == null) {
                    pushSla = false;
                  } else if (_frete.tipo != "Agendada") {
                    c.sla = slaCart.totalTime;
                    c.valorFrete =
                      slaCart.listPrice < slaCart.minimum_MoneyCost
                        ? slaCart.minimum_MoneyCost
                        : slaCart.listPrice;
                  }
                });
                if (pushSla) {
                  sla.push(_frete);
                }
              }
            );
          }
          localStorage.setItem("carrinho", JSON.stringify(carrinho));
          this.sla = sla;
        }
      }
    },

    async getClient() {
      let documento = this.cpfcnpj;
      const response = await axios({
        method: "GET",
        url: `https://www.leverosintegra.com.br/Map/api/Client/${documento}?token=EB973B79-477A-4F62-AD73-A96E00BFB269`,
      });
      this.infos = response.data.Dados;

      // Limpa os dados do cliente
      this.client = cleanClient()

      // Atualiza exibição
      this.client.name = this.infos.tpPessoa === "F" ? this.infos.nmcliente_razao : null
      this.client.email = this.infos.email
      this.client.phone = `(${this.infos.telefone[0].DDD}) ${this.infos.telefone[0].NRTelefone}`
      this.client.stateRegistration = this.infos.inscricao
      this.client.corporateName = this.infos.tpPessoa !== "F" ? this.infos.nmcliente_razao : null
      this.client.fantasyName = this.infos.tpPessoa !== "F" ? this.infos.nmfantazia : null
    },
  },

  async created() {
    // Recupera o carrinho
    this.carrinho = JSON.parse(localStorage.getItem("carrinho"))
    let dados = JSON.parse(localStorage.getItem("login"))
    this.usuarioLogado = dados.nomeUsuarioLogado

    console.log(this.carrinho[0].prazoMaior)

    // Calcula o valor total do carrinho
    let totalCarrinho = 0
    let isCustomized = false
    this.carrinho.forEach(c => {
      isCustomized = c.isCustomized
      totalCarrinho += parseFloat(c.valor) * parseFloat(c.quantidade)
    })

    // Valida se é um kit
    this.isCustomized = isCustomized

    // Atualiza a váriavel com o valor total do Carrinho
    this.totalCarrinho = parseFloat(totalCarrinho.toFixed(2));

    // Recupera as formas de pagamento
    try {
      const resp = await axios.get(
        `https://www.leverosintegra.com.br/Map/Api/PaymentsMethod?solar=true`
      )
      this.formaPagamentoSolar = resp.data;
      // this.formaPagamentoSolar.push({
      //   "id":900.0,
      //   "descricao":"PROFITZ",
      //   "condicoesDePagamento":[
      //     {
      //       "id":1.0,
      //       "descricao":"1x",
      //       "descontoMaximo":0.0,
      //       "percentualRT":0.0,
      //       "adquirente":0.0
      //     }
      //   ]
      // })
      if(this.isPartner === true){
        this.formaPagamentoSolar = this.formaPagamentoSolar.filter(x => x.descricao !== 'FINANCIAMENTO')
        this.formaPagamentoSolar = this.formaPagamentoSolar.filter(x => x.descricao !== 'FINANCIAMENTO SANTANDER')
        this.formaPagamentoSolar = this.formaPagamentoSolar.filter(x => x.descricao !== 'FINANCIAMENTO BV')
        this.formaPagamentoSolar = this.formaPagamentoSolar.filter(x => x.descricao !== 'BOLETO PARCELADO')
      }
    } catch (err) {
      console.log(err)
    }
    if (dados.Parceiros != undefined) {
      this.parceiros = dados.Parceiros.filter(par => par.saleChannel === parseInt(JSON.parse(localStorage.getItem("saleChannel"))));
    }
    //Consulta saldo Profitz
    const saldoProfitz = await axios.get(`https://leverosintegra.dev.br/api/bcdigital/registerOld/${dados.cpfCnj}`)
    if(saldoProfitz.data.card_balance != undefined){
      this.valorProfitz = parseFloat(saldoProfitz.data.card_balance) / 100;
			this.cnpjProfitz = dados.cpfCnj;
    }
    else{
      this.valorProfitz = 0;
    }
  },

  beforeMount() {
    if (localStorage.getItem("carrinho") === null) {
      localStorage.setItem("carrinho", []);
    }
    let dados = JSON.parse(localStorage.getItem("login"));
    let perfil = dados.perfil;
    let valida = perfil.filter( x => x.NomePerfil === 'PARCEIRO')
    if(valida.length == 0){
      localStorage.setItem("perfilParceiro", false)
    } else {
      localStorage.setItem("perfilParceiro", true)
      this.isPartner = true;
    }
  },
};
</script>

<style lang="scss" scoped>
input[type="text"]:disabled,
input[type="email"]:disabled,
input[type="tel"]:disabled,
input[type="checkbox"]:disabled {
  background: #e7e7e7;
}
.checkout {
  display: flex;
  justify-content: space-between;
  max-width: 90%;
  margin: 0 auto;
  padding-top: 30px;

  @media (max-width: 768px) {
    flex-direction: column;
  }

  &__infosUser {
    width: 60%;
    border-right: 1px solid #e7e2e2;

    @media (max-width: 768px) {
      width: 100%;
      border-right: none;
      border-bottom: 1px solid #e7e2e2;
    }
  }

  &__resumeOrder {
    width: 40%;
    padding: 30px 10px;
    position: sticky;
    top: 50px;
    height: 100%;

    @media (max-width: 768px) {
      width: 100%;
      padding: 30px 0;
    }

    h1 {
      font-size: 0.875rem;
    }
  }

  &__resume {
    padding-top: 30px;

    &--items {
      border-bottom: 1px solid #e5e5e5;
      padding: 10px 0 0 0;

      &--name {
        display: flex;
        align-items: center;

        p {
          padding-left: 25px;
          font-size: 0.813rem;

          a {
            text-decoration: none;
            color: #150d1c;
          }
        }
      }

      &--valor {
        display: flex;
        justify-content: flex-end;
        padding-bottom: 15px;

        p {
          font-size: 0.813rem;
          font-weight: bold;

          &:first-child {
            padding-right: 20px;
          }
        }
      }
    }

    &--totais {
      padding-top: 30px;

      &--subtotal,
      &--shipping,
      &--totais {
        display: flex;
        justify-content: space-between;
        padding: 10px 0;
        font-size: 0.875rem;
      }
    }

    &--finalizarCompra {
      button {
        background: #002d32;
        color: #fff;
        font-size: 0.938rem;
        font-weight: bold;
        padding: 7px;
        width: 100%;
        text-align: center;
        border-radius: 5px;
        outline: none;
        margin-top: 40px;
        box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
          0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
        letter-spacing: 0.0892857143rem;
      }
    }

    &--finalizarOrcamento {
      button {
        border: 1px solid #4cdddd;
        color: #4cdddd;
        font-size: 0.875rem;
        font-weight: bold;
        padding: 7px;
        width: 100%;
        text-align: center;
        border-radius: 5px;
        outline: none;
        margin-top: 20px;

        &:hover {
          background: #4cdddd;
          color: #fff;
        }
      }
    }
  }

  &__informacoesIniciais {
    padding: 40px 40px 20px 40px;

    @media (max-width: 768px) {
      padding: 20px 0;
    }

    h1 {
      font-size: 0.875rem;
      padding-bottom: 20px;
    }
  }

  &__dadosPessoais {
    padding: 40px 0 0 40px;

    @media (max-width: 768px) {
      padding: 20px 0 0 0;
    }

    h1 {
      font-size: 0.875rem;
      padding-bottom: 20px;
    }
  }

  &__pessoaJuridica {
    padding: 0 40px;

    @media (max-width: 768px) {
      padding: 0;
    }

    &--span {
      font-size: 0.75rem;
      padding-left: 5px;
    }
  }

  &__enderecoEntrega {
    padding: 40px;

    @media (max-width: 768px) {
      padding: 20px 0;
    }

    h1 {
      font-size: 0.875rem;
      padding-bottom: 20px;
    }

    label span {
      color: #a1a1a1;
      font-size: 0.688rem;
    }

    &--opcoes {
      display: flex;
      flex-wrap: wrap;
      padding-bottom: 30px;

      &--item {
        border: 1px solid #a1a1a1;
        border-radius: 5px;
        padding: 10px;
        margin: 5px 10px 5px 0;
        width: 30%;
        font-size: 0.875rem;

        @media (max-width: 440px) {
          width: 45%;
        }

        span {
          padding-left: 5px;
        }

        p {
          line-height: 1.6;
        }

        &:hover {
          background: #f3f3f3;
        }
      }
    }

    &--novoEndereco {
      a {
        /*background: #005a64;
        color: #fff;*/
        padding: 0;
        border-radius: 5px;
        text-decoration: none;
        text-transform: uppercase;
        font-size: 0.775rem;
        /*box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
          0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);*/
        letter-spacing: 0.0492857143rem;
      }

      &--form {
        padding-top: 30px;
      }
    }

    &--faturamento {
      margin: 0 0 40px 40px;
      a {
        color: #878787;
        font-weight: 700;
        font-size: 0.875rem;
        text-decoration: underline;
        cursor: pointer;
      }

      &--form {
        padding-top: 20px;
      }
    }
  }

  &__opcoesEnvio {
    padding: 0 40px;

    @media (max-width: 768px) {
      padding: 20px 0;
    }

    h1 {
      font-size: 0.875rem;
      padding-bottom: 20px;
    }

    span {
      padding-left: 10px;
      font-size: 0.75rem;
    }

    &--loader {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      i {
        color: #4cdddd;
      }

      span:nth-child(2) {
        font-size: 0.75rem;
        padding-top: 10px;
      }
    }
  }

  &__profitz {
    &--points {
      font-weight: bold;
      font-size: 0.875rem;
      color: #005a64;
    }

    &--addPoints {
      background: #005a64;
      border-radius: 5px;
      color: #fff;
      padding: 5px;
      font-weight: bold;
      margin: 10px 0;

      @media (max-width: 768px) {
        width: 140px;
      }
    }
  }

  &__infosRT {
    padding: 20px 40px;

    @media (max-width: 768px) {
      padding: 20px 0;
    }

    h1 {
      font-size: 0.875rem;
      padding-bottom: 20px;
    }
  }

  &__pagamentoClimatizacao {
    &--tab {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-bottom: 30px;
    }
  }

  &__pagamentoSolar {
    &--tab {
      display: flex;
      align-items: center;
      margin-bottom: 30px;
    }
  }

  &__pagamentoClimatizacao,
  &__pagamentoSolar {
    padding: 20px 40px;

    @media (max-width: 768px) {
      padding: 20px 0;
    }

    h1 {
      font-size: 0.875rem;
      padding-bottom: 20px;
    }

    &--tabcontent {
      display: none;

      p {
        font-size: 0.813rem;
        line-height: 1.4;
        padding: 10px 0;
      }

      h3 {
        padding: 30px 0 15px 0;
      }
    }

    &--tablinks {
      display: flex;
      flex-direction: column;
      align-items: center;
      border: 1px solid #a1a1a1;
      background: #f0f0f0;
      border-radius: 5px;
      height: 60px;
      width: 150px;
      font-size: 0.75rem;
      margin: 5px;
      cursor: pointer;

      @media (max-width: 768px) {
        height: 70px;
        text-align: center;
        font-size: 0.688rem;
        margin: 0 2px;
      }

      &:hover {
        background: #d1d1d1;
        .dropdown-content {
          display: block !important;
        }
      }

      .dropdown {
        position: relative;
        z-index: 999;
      }

      .dropdown-content {
        margin-top: 59px;
        display: none;
        position: absolute;
        background-color: #f9f9f9;
        min-width: 200px;
        box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
        z-index: 1;
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
      }

      .dropdown-content a {
        color: black;
        padding: 12px 16px;
        text-decoration: none;
        display: block;
      }

      .item-dropdown-content {
        position: relative;
        z-index: 99999;
      }

      span {
        font-size: 0.625rem;
      }
    }
    &--row {
      display: flex;
      flex-direction: column;
    }
  }

  &__observacoes {
    padding: 20px 40px;

    @media (max-width: 768px) {
      padding: 20px 0;
    }

    h3 {
      font-size: 0.875rem;
      padding-bottom: 20px;
    }

    textarea {
      border: 1px solid #b8b8b8;
      border-radius: 5px;
      outline: none;
      resize: none;
      padding: 20px;
      color: #505050;
      font-size: 0.875rem;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;

      width: 100%;
    }
  }

  .active {
    background: #6fffaf;
    color: #000;
    fill: #000;
  }

  .rows {
    display: flex;
    padding: 5px 0;

    @media (max-width: 768px) {
      flex-direction: column;
      padding: 0;
    }

    &--checkbox {
      @media (max-width: 768px) {
        flex-direction: row;
      }
    }
  }

  .form-groups {
    display: flex;
    flex-direction: column;
    margin: 0 30px 0 0;
  }

  .large {
    width: 350px;

    @media (max-width: 768px) {
      width: 310px;
    }
  }

  .small {
    width: 110px;

    @media (max-width: 768px) {
      width: 90px;
    }
  }

  .medium {
    width: 210px;

    @media (max-width: 768px) {
      width: 190px;
    }
  }

  .input {
    padding: 7px 15px;
    border: 1px solid #a1a1a1;
    border-radius: 5px;
    outline: none;
    text-transform: uppercase;
    font-size: 0.75rem;
  }

  .label {
    font-size: 0.75rem;
    padding: 10px 0;
  }

  input[type="text"]:disabled {
    padding: 7px;
    border-radius: 5px;
  }
}

.dropdown {
  position: relative;
}

.dropdown-content {
  margin-top: 59px;
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 200px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}

.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropdown-content a:hover {
  background-color: #f1f1f1;
}

.dropdown:hover .dropdown-content {
  display: block;
}

::v-deep .v-application--wrap {
  min-height: fit-content;
}

.custom-slider {
  width: 100%;
  height: 2px;
  accent-color: #005a64;
}

.nao-selecionar {
  -webkit-user-select: none;
  -moz-user-select: -moz-none;
  -ms-user-select: none;
  user-select: none;
}
</style>
